import { ProjectAction, ProjectByLastWeekAction } from "../types/projectDataSQP"
import { Dispatch } from "react"
import { ProjectActionType } from "../types/projectDataSQP"
import projectApi from "../../api/projectDataSQPApi"

interface IGetProjectDataSQP {
  projectId: string
}

function getProjectDataSQP(params: IGetProjectDataSQP) {
  const { projectId } = params
  return async (dispatch: Dispatch<ProjectAction>) => {
    try {
      dispatch({ type: ProjectActionType.FETCH_PROJECT_DATA_SQP })
      const response = await projectApi.getSQPData({ projectId })
      dispatch({ type: ProjectActionType.FETCH_PROJECT_DATA_SQP_SUCCESS, payload: response })
    } catch (error) {
      dispatch({
        type: ProjectActionType.FETCH_PROJECT_DATA_SQP_ERROR,
        payload: "Error loading projects",
      })
    }
  }
}

interface IGetProjectDataSQPByLastWeek {
  projectId: string
  searchQuery: string
  lastDate: string
}

function getProjectDataSQPByLastWeek(params: IGetProjectDataSQPByLastWeek) {
  const { projectId, searchQuery, lastDate } = params
  return async (dispatch: Dispatch<ProjectByLastWeekAction>) => {
    try {
      dispatch({ type: ProjectActionType.FETCH_PROJECT_DATA_SQP_BY_LAST_WEEK })
      const response = await projectApi.getSQPData({ projectId, searchQuery, lastDate })
      dispatch({
        type: ProjectActionType.FETCH_PROJECT_DATA_SQP_SUCCESS_BY_LAST_WEEK,
        payload: response,
      })
    } catch (error) {
      dispatch({
        type: ProjectActionType.FETCH_PROJECT_DATA_SQP_ERROR_BY_LAST_WEEK,
        payload: "Error loading projects",
      })
    }
  }
}

export default {
  getProjectDataSQP,
  getProjectDataSQPByLastWeek,
}
